import Vue from 'vue'
// import VueGoogleMaps from 'vue-googlemaps'
// import 'vue-googlemaps/dist/vue-googlemaps.css'

// Vue.use(VueGoogleMaps, {
//   load: {
//     // Google API key
//     apiKey: process.env.VUE_APP_GOOGLE_MAPS,
//     // Enable more Google Maps libraries here
//     libraries: ['marker'],
//     // Use new renderer
//     useBetaRenderer: false,
//   },
// })
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS,
    libraries: 'marker'
  }
})
